// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2OGsD","content":"styles_content__lWStx","checkbox":"styles_checkbox__2tGCD","checkboxLabel":"styles_checkboxLabel__1cWsL"};